import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table-v6'
import { map, compact } from 'lodash'

import { ClusterReportFilters as Filters, filteredData } from './Filters';

const VcenterAssetReportClusters = ({ clusters, sites }) => {
  const [filters, changeFilters] = useState({ sites: 'all', inSite: 'all' })
  const filterOptions = {
    sites: map(compact(sites), ({ code, name }) => ({ label: name, value: code }))
  }

  const columns = [
    { Header: 'Site', accessor: 'site.name' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'IP', accessor: 'server' },
  ]

  return (
    <Fragment>
      <Filters {...{ filters, changeFilters, filterOptions }} />

      <ReactTable
        data={filteredData({ clusters, filters })}
        columns={columns}
        minRows={0}
        filterable
        defaultFilterMethod={(filter, row) => includes(row[filter.id], filter.value)}
      />
    </Fragment>
  )
}

export default VcenterAssetReportClusters
